import { Flex, Text } from "@chakra-ui/react";
import { ReactNode } from "react";

/** Number of orders / returns / projects / subscriptions in the frontend hero component partner stats. */
export function CountTag({ count }: { count: number | string }): ReactNode {
  return (
    <Flex paddingX="8px" alignItems="center" borderRadius="12px" background="brand.yellow">
      <Text fontSize="xs" fontWeight="semibold">
        {count}
      </Text>
    </Flex>
  );
}
